import { Badge } from '@/components/ui/badge';
import { AnnouncementTypeMetadataMap } from '@/lib/announcement-utils';
import { AnnouncementType, AnnouncementTypeLabelMap } from '@airreading/common/data';
import clsx from 'clsx';

export interface AnnouncementTypeProps {
  type: AnnouncementType;
}

export const AnnouncementTypeBadge = ({ type }: AnnouncementTypeProps) => {
  const metadata = AnnouncementTypeMetadataMap[type];
  const { bgClass, textClass } = metadata;

  return (
    <Badge variant="default" className={clsx(bgClass, textClass)}>
      {AnnouncementTypeLabelMap[type]}
    </Badge>
  );
};
